export default {
  GET_ARTICLE_REQUESTED: 'GET_ARTICLE_REQUESTED',
  GET_ARTICLE_SUCCEEDED: 'GET_ARTICLE_SUCCEEDED',
  GET_ARTICLE_FAILED: 'GET_ARTICLE_FAILED',
};
